// extracted by mini-css-extract-plugin
export default {"button":"Delete_button__DA8vN","icon":"Delete_icon__bSq0m"};